module.exports = __webpack_public_path__ + "img/diagram-3.6570d89c.svg";